import React from 'react'
import DateBox from "./DateBox";
import DatePicker from "react-datepicker/es";
import MewsApi from "../service/MewsApi";

/**
 * Handles the end date selection
 */
class EndDateSelector extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        const EndDateTrigger = ({ value, onClick }) => {

            const startDate = value ? new Date(value) : new Date();

            return (

                <button className="mews-date-btn" onClick={onClick}>
                    <div className="mews-startDate"><DateBox dateIso8601={startDate.toISOString()} /></div>
                </button>

            );
        }

        return (
            <div className="mews-endDateSelector">
                <DatePicker
                    selected={this.props.endDate}
                    onChange={date => this.props.onEndDateChange(date)}
                    filterDate={MewsApi.isPossibleStartDate}
                    placeholderText="Select a weekday"
                    minDate={MewsApi.getMinEndDate()}
                    customInput={<EndDateTrigger />}
                    popperPlacement="top"
                />
            </div>
        );
    }
}


export default EndDateSelector